module.exports = __webpack_public_path__ + "static/img/img-empty@3x.972ca5d2.png";